/*
 * Public API Surface of shared
 */
export * from './devextreme-license';
export * from './lib/annotations/sia-base-script.annotation';
export * from './lib/apis/file-api';
export * from './lib/apis/sia-component-api';
export * from './lib/apis/sia-component-config-api';
export * from './lib/apis/sia-email.api';
export * from './lib/apis/sia-external-sources-api';
export * from './lib/apis/sia-i18n-api';
export * from './lib/apis/sia-icon-badge.api';
export * from './lib/apis/sia-layout.api';
export * from './lib/apis/sia-menu.api';
export * from './lib/apis/sia-permissions.api';
export * from './lib/apis/sia-pwa.api';
export * from './lib/apis/sia-report-print.api';
export * from './lib/apis/sia-router.api';
export * from './lib/apis/sia-select-box-data-api';
export * from './lib/apis/sia-session.api';
export * from './lib/apis/sia-sqlquery.api';
export * from './lib/apis/sia-users.api';
export * from './lib/apis/sia-utils.api';
export * from './lib/apis/wallet-pass.api';
export * from './lib/components/sia-accordion/sia-accordion.component';
export * from './lib/components/sia-avatar/sia-avatar.component';
export * from './lib/components/sia-base-pdf-viewer/sia-base-pdf-viewer';
export * from './lib/components/sia-base-script/sia-base-script.component';
export * from './lib/components/sia-cell-avatar/sia-cell-avatar.component';
export * from './lib/components/sia-iframe/sia-iframe.component';
export * from './lib/components/sia-search-box/sia-search-box.component';
export * from './lib/db/ngx-indexed-db';
export * from './lib/db/ngx-indexed-db-utils';
export * from './lib/db/ngx-indexed-db.meta';
export * from './lib/db/ngx-indexed-db.service';
export * from './lib/dialogs/base-dialog';
export * from './lib/dialogs/crud-dialog/crud-dialog.component';
export * from './lib/dialogs/perspective-level-dialog/perspective-level-dialog.component';
export * from './lib/dialogs/prompt-dialog';
export * from './lib/dialogs/sia-choice-dialog/sia-choice-dialog';
export * from './lib/dialogs/sia-error-dialog/sia-error-dialog';
export * from './lib/dialogs/sia-pdf-viewer-dialog/sia-pdf-viewer-dialog';
export * from './lib/dialogs/sia-pwa-install-instructions-dialog/sia-pwa-install-instructions-dialog.component';
export * from './lib/dialogs/stepper-dialog';
export * from './lib/dialogs/yes-no-dialog/yes-no-dialog';
export * from './lib/dialogs/yes-no-feedback-dialog/yes-no-feedback-dialog';
export * from './lib/directives/context-mat-menu.directive';
export * from './lib/directives/disable-tooltips.directive';
export * from './lib/directives/horizontal-scroll.directive';
export * from './lib/directives/init.directive';
export * from './lib/directives/inject-html.directive';
export * from './lib/directives/lazy-src.directive';
export * from './lib/directives/lazy-viewport.directive';
export * from './lib/directives/outside-click.directive';
export * from './lib/directives/overflow-tooltip.directive';
export * from './lib/directives/scroll-bottom.directive';
export * from './lib/directives/sia-auto-color-contrast.directive';
export * from './lib/directives/sia-autofocus.directive';
export * from './lib/directives/sia-fitText.directive';
export * from './lib/directives/sia-i18n.directive';
export * from './lib/directives/sia-keyboard-focus.directive';
export * from './lib/directives/sia-stop-click.directive';
export * from './lib/directives/tooltip.directive';
export * from './lib/directives/visibility.directive';
export * from './lib/guards/sia-admin.guard';
export * from './lib/guards/sia-auth.guard';
export * from './lib/interceptors/sia-cache.interceptor';
export * from './lib/interceptors/sia-date.interceptor';
export * from './lib/interfaces/category-field';
export * from './lib/interfaces/company-info';
export * from './lib/interfaces/crud-dialog-data';
export * from './lib/interfaces/drawer-configuration';
export * from './lib/interfaces/filter-config';
export * from './lib/interfaces/languages';
export * from './lib/interfaces/request-params';
export * from './lib/interfaces/send-template-email-request';
export * from './lib/interfaces/shell-view-mode';
export * from './lib/interfaces/sia-cache-data';
export * from './lib/interfaces/sia-choice';
export * from './lib/interfaces/sia-component-config-perspectives';
export * from './lib/interfaces/sia-component-info';
export * from './lib/interfaces/sia-component-user-permissions';
export * from './lib/interfaces/sia-constants';
export * from './lib/interfaces/sia-date';
export * from './lib/interfaces/sia-file-archive';
export * from './lib/interfaces/sia-file-chunk';
export * from './lib/interfaces/sia-file-interface';
export * from './lib/interfaces/sia-file-path';
export * from './lib/interfaces/sia-file-tree-node';
export * from './lib/interfaces/sia-icon';
export * from './lib/interfaces/sia-layout';
export * from './lib/interfaces/sia-menu';
export * from './lib/interfaces/sia-navigation';
export * from './lib/interfaces/sia-operator';
export * from './lib/interfaces/sia-permissions-config';
export * from './lib/interfaces/sia-profile-address';
export * from './lib/interfaces/sia-profile-notifications';
export * from './lib/interfaces/sia-report';
export * from './lib/interfaces/sia-session-param';
export * from './lib/interfaces/sia-signalr-message';
export * from './lib/interfaces/sia-signalr-status-message';
export * from './lib/interfaces/sia-sql-filters';
export * from './lib/interfaces/sia-table-informations';
export * from './lib/interfaces/sia-template-configuration';
export * from './lib/interfaces/sia-template-notification.interface';
export * from './lib/interfaces/sia-token-user';
export * from './lib/interfaces/sia-translations';
export * from './lib/interfaces/sia-user';
export * from './lib/interfaces/sia-user-permissions';
export * from './lib/interfaces/sia-window-size';
export * from './lib/interfaces/synced-calendar';
export * from './lib/interfaces/table-filter';
export * from './lib/interfaces/template';
export * from './lib/interfaces/user-token-calendars';
export * from './lib/interfaces/wallet-pass';
export * from './lib/pipes/break-line.pipe';
export * from './lib/pipes/bytes-converter.pipe';
export * from './lib/pipes/file-preview.pipe';
export * from './lib/pipes/filter-array.pipe';
export * from './lib/pipes/integer-date.pipe';
export * from './lib/pipes/resources-url.pipe';
export * from './lib/pipes/safe-html.pipe';
export * from './lib/pipes/safe-url.pipe';
export * from './lib/pipes/sia-format-number.pipe';
export * from './lib/pipes/sia-img-src-url.pipe';
export * from './lib/pipes/sia-translate.pipe';
export * from './lib/providers/default-route-reuse-strategy';
export * from './lib/providers/form-field-appearance.provider';
export * from './lib/services/base-action.service';
export * from './lib/services/cache-database.service';
export * from './lib/services/component-config.service';
export * from './lib/services/component.service';
export * from './lib/services/date.service';
export * from './lib/services/defaults.service';
export * from './lib/services/department-overlay.service';
export * from './lib/services/dxutils.service';
export * from './lib/services/email.service';
export * from './lib/services/envirorment.service';
export * from './lib/services/external-sources.service';
export * from './lib/services/file.service';
export * from './lib/services/functions-utils.service';
export * from './lib/services/gps.service';
export * from './lib/services/http.service';
export * from './lib/services/i18n.service';
export * from './lib/services/icon-badge.service';
export * from './lib/services/image.service';
export * from './lib/services/indexed-db.service';
export * from './lib/services/jsonDeepClone';
export * from './lib/services/layout.service';
export * from './lib/services/lazy-viewport.service';
export * from './lib/services/menu.service';
export * from './lib/services/new-router.service';
export * from './lib/services/notify';
export * from './lib/services/number.service';
export * from './lib/services/params-and-patterns.service';
export * from './lib/services/permissions.service';
export * from './lib/services/pre-filters.service';
export * from './lib/services/push-notifications.service';
export * from './lib/services/pwa.service';
export * from './lib/services/radar.service';
export * from './lib/services/report-print.service';
export * from './lib/services/runtime-config';
export * from './lib/services/service-worker-update.service';
export * from './lib/services/session.service';
export * from './lib/services/setup-portrait-keyboard-resize';
export * from './lib/services/shell-view-mode.service';
export * from './lib/services/sia-component.service';
export * from './lib/services/sia-pwa-install.service';
export * from './lib/services/sia-select-box-data.service';
export * from './lib/services/sia-template-notification.service';
export * from './lib/services/sia-wake-lock.service';
export * from './lib/services/signalr.service';
export * from './lib/services/size-detector.service';
export * from './lib/services/sort-menus-by-group-min-order';
export * from './lib/services/sound.service';
export * from './lib/services/sqlquery.service';
export * from './lib/services/subtitle.service';
export * from './lib/services/swipe-gesture.service';
export * from './lib/services/theme.service';
export * from './lib/services/token-store.service';
export * from './lib/services/topbar-cart.service';
export * from './lib/services/users.service';
export * from './lib/services/utils.service';
export * from './lib/services/voice-to-text.service';
export * from './lib/services/wallet-pass.service';
export * from './lib/services/with-timeout';
export * from './lib/utils/color-contrast';
export * from './lib/utils/country-names-it';
